// Canonical public URLs for the always-up-to-date hosted legal documents. The app also
// bundles the text (rendered offline in a bottom sheet); these links point at the live
// web versions so users can confirm the latest revision when they have connectivity.
export const HANIVERSE_TERMS_URL = "https://haniverse.app/terms";
export const HANIVERSE_PRIVACY_URL = "https://haniverse.app/privacy";
